<template>
  <v-card class="rounded-lg">
    <v-card-title id="head">Template </v-card-title>
    <v-icon
      class="close"
      size="35"
      @click="$store.commit('common/changeTemplateModalView')"
      >mdi-window-close</v-icon
    >

    <div style="margin: 20px 4% 0px; position: relative">
      <div style="display: flex">
        <div class="description">
          <span>CustNum</span>
          <span>{{ custNumber }}</span>
          <span>Company</span>
          <span>{{ company }}</span>
        </div>
        <div style="width: 20%">
          <v-btn
            @click="$store.commit('common/changeEditTemplateModalView')"
            class="rounded-lg"
            color="#05523E"
            style="color: #ffffff; float: right"
          >
            Edit Template
          </v-btn>
        </div>
      </div>
      <v-data-table
        class="elevation-5"
        style="margin: 20px auto 0px"
        :headers="headers"
        item-key="_id"
        :items="$store.state.invoice.templateList"
        :page.sync="page_No"
        :items-per-page="$store.state.invoice.templateList.length"
        hide-default-footer
        :loading="loading"
        loading-text="Loading... Please wait"
      >
        <!-- <template v-slot:header="{ props: { headers } }">
                    <thead>
                        <tr>
                            <th v-for="h in headers" v-bind:key="h.text">
                                <span style="color: black; font-weight: bold; font-size: 17px;">{{h.text}}</span>
                            </th>
                        </tr>
                    </thead>
                </template> -->
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.itemNum }}</td>
            <td>{{ item.itemName }}</td>
            <td>{{ item.company }}</td>
            <td>{{ item.dept }}</td>
            <td>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="transparent"
                    class="elevation-0"
                    ><v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item-title
                    @click="deleteTemplate(item._id)"
                    style="padding: 0px 15px; font-size: 15px; cursor: pointer"
                    >Delete</v-list-item-title
                  >
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-card-actions style="justify-content: center">
        <v-btn
          class="action white--text elevation-5"
          color="#05523E"
          style="
            max-width: 120px;
            min-width: 100px;
            font-size: 15px;
            font-weight: bold;
            height: 35px;
            margin: 12px;
          "
          @click="$store.commit('common/changeTemplateModalView')"
          >{{ !isAddTemplate ? "OK" : "ADD" }}</v-btn
        >
      </v-card-actions>
      <div v-if="$store.state.common.editTemplateModalView">
        <v-dialog
          v-model="$store.state.common.editTemplateModalView"
          width="1900"
        >
          <EditTemplateModal
            v-bind:custNumber="custNumber"
            @getTemplateOne="getTemplateOne"
          />
        </v-dialog>
      </div>
    </div>
  </v-card>
</template>

<script>
import EditTemplateModal from "@/components/modal/EditTemplateModal.vue";

export default {
  components: {
    EditTemplateModal,
  },
  data() {
    return {
      selected: [],
      singleSelect: true,
      headers: [
        {
          text: "Item Number",
          align: "start",
          value: "itemNum",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Item Name",
          value: "itemName",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Vendor Name",
          value: "company",
        },
        {
          text: "Department",
          value: "dept",
        },
        { text: "", value: "", sortable: false },
      ],
      page_No: 1,
      custNumber: this.custNum,
      company: this.companyName,
    };
  },
  props: ["custNum", "companyName", "loading", "isAddTemplate"],
  mounted() {
    console.log(this.custNum);
    console.log(this.company);
  },
  methods: {
    addTemplateList() {
      this.$emit("addTemplateList", this.selected);
    },
    async deleteTemplate(_id) {
      try {
        await this.$store.dispatch("invoice/deleteTemplate", { _id: _id });
        await this.$store.dispatch("invoice/getTemplates", {
          CustNum: this.custNumber,
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getTemplateOne() {
      try {
        await this.$store.dispatch("invoice/getTemplates", {
          CustNum: this.custNumber,
        });
      } catch (e) {
        console.log(e);
      }
    },
  },
  async beforeDestroy() {
    this.$store.state.invoice.templateList = await [];
  },
};
</script>

<style lang="scss" scoped>
#head {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 33px;
  font-weight: bold;
  color: #05523e;
  padding-top: 35px;
}
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  color: black;
}
.description {
  width: 80%;
  display: flex;
  flex-wrap: wrap;
}
.description > span:nth-child(1),
span:nth-child(3) {
  font-size: 22px;
  font-weight: bold;
  width: 105px;
}
.description > span:nth-child(2),
span:nth-child(4) {
  font-size: 22px;
  font-weight: 400;
  width: 330px;
}
.description > span:nth-child(2) {
  width: 240px;
}
</style>
